import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchSignalHistoryRequest,
  fetchLocationHistoryRequest,
  fetchBatteryHistoryRequest,
  fetchAcclerationHistoryRequest,
  fetchGatewayTelemetryHistoryRequest,
  fetchAssetHistoryRequest,
  fetchShockAlarmHistoryRequest,
} from "../../../store/actions/deviceDashboard";
import ReactECharts from "echarts-for-react";

import battery from "../../../assets/battery.svg";

import NotFound from "../Not-Found";
import LocationHistory from "./common/locationHistory";
import GatewayTelemetry from "./common/gatewayTelemetry";
// import ShockAnalyticsDashboard from "./common/ShockAnalyticsDashboard";

import batteryOptions from "./graphs-config/battery";
import accelarationHistoryOptions from "./graphs-config/accelaration_history";
import signalHistoryOptions from "./graphs-config/signal_history";
import shockOptions from "./graphs-config/shock";
import { mapboxToken,mapboxStyle } from "../../../configuration";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import SettingDropdown from "./common/SettingDropdown";
import ResolutionDropdown from "./common/ResolutionDropdown";

function GatewayDeviceDashboard(props) {
  const { id, isRefresh } = props;
  const dispatch = useDispatch();
  const batteryLevelFullScreenRef = useRef();
  const gpsHeatMapFullScreenRef = useRef();
  const signalHistoryFullScreenRef = useRef();
  const accelarationHistoryFullScreenRef = useRef();
  const locationGatewayHistoryFullScreenRef = useRef();
  const gatewayTelementryFullScreenRef = useRef();
  const shockAlarmFullScreenRef = useRef();

  const isBatteryHistoryLoading = useSelector(
    (state) => state.deviceDashboard.isLoading.batteryHistory
  );
  const isAccelerationHistoryLoading = useSelector(
    (state) => state.deviceDashboard.isLoading.accelerationHistory
  );
  const isSignalHistoryLoading = useSelector(
    (state) => state.deviceDashboard.isLoading.signalHistory
  );
  const isLocationHistoryLoading = useSelector(
    (state) => state.deviceDashboard.isLoading.locationHistory
  );
  const isGatewayTelemetryHistoryLoading = useSelector(
    (state) => state.deviceDashboard.isLoading.gatewayTelemetryHistory
  );
  const isShockAlarmHistoryLoading = useSelector(
    (state) => state.deviceDashboard.isLoading.shockAlarmHistory
  );

  const batteryHistory = useSelector(
    (state) => state.deviceDashboard.data.batteryHistory
  );
  const accelerationHistory = useSelector(
    (state) => state.deviceDashboard.data.accelerationHistory
  );

  const signalHistory = useSelector(
    (state) => state.deviceDashboard.data.signalHistory
  );
  const locationHistory = useSelector(
    (state) => state.deviceDashboard.data.locationHistory
  );
  const gatewayTelemetryHistory = useSelector(
    (state) => state.deviceDashboard.data.gatewayTelemetryHistory
  );
  const assetHistory = useSelector(
    (state) => state.deviceDashboard.data.assetHistory
  );
  const shockAlarmHistory = useSelector(
    (state) => state.deviceDashboard.data.shockAlarmHistory
  );

  const user = useSelector((state) => state.auth.user);
  //console.log(assetHistory)
  // const assetmapdata = assetHistory?.data?.length > 0 && assetHistory?.data?.map((item, index) => ({
  //   id: index + 1,
  //   coordinates: [item?.fields?.location?.longitude, item?.fields?.location?.latitude],
  //   lastupdated: item?.lastupdated
  // }));
  // dummyData = {
  //   type: "FeatureCollection",
  //   features: assetmapdata.length > 0 && assetmapdata.map((point, idx) => ({
  //     type: "Feature",
  //     geometry: {
  //       type: "Point",
  //       coordinates: point.coordinates,
  //     },
  //     properties: {
  //       id: point.id,
  //       color: idx === 0
  //         ? "#05A94D"
  //         : idx === assetmapdata.length - 1
  //           ? "#C02B03"
  //           : "#09C3F1",
  //       number: point.id,
  //     },
  //   }))
  // };
  function handleBatteryResolution(val) {
    dispatch(
      fetchBatteryHistoryRequest({
        id,
        resolutionFilterKey: "battery",
        resolutionFilter: {
          duration: val.duration,
          resolution: val.resolution,
        },
      })
    );
  }

  function handleAcclerationResolution(val) {
    dispatch(
      fetchAcclerationHistoryRequest({
        id,
        resolutionFilterKey: "acceleration",
        resolutionFilter: {
          duration: val.duration,
          resolution: val.resolution,
        },
      })
    );
  }

  function handleShockAlarmResolution(val) {
    dispatch(
      fetchShockAlarmHistoryRequest({
        id,
        resolutionFilterKey: "shockAlarm",
        resolutionFilter: {
          duration: val.duration,
          resolution: val.resolution,
        },
      })
    );
  }

  function handleSignalResolution(val) {
    dispatch(
      fetchSignalHistoryRequest({
        id,
        resolutionFilterKey: "signalStrength",
        resolutionFilter: {
          duration: val.duration,
          resolution: val.resolution,
        },
      })
    );
  }

  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  useEffect(() => {
    if(Array.isArray(assetHistory) && assetHistory.length < 1) {
      return;
    }
    mapboxgl.accessToken = mapboxToken;

    if (!mapboxgl.supported()) {
      console.error("WebGL is not supported in this browser. Map cannot be initialized.");
      return;
    }
    try {
      mapRef.current = new mapboxgl.Map({
        container: mapContainerRef.current,
        style:mapboxStyle,
       // style: "mapbox://styles/mapbox/streets-v11",
        center: assetHistory?.features[0]?.geometry?.coordinates,
        zoom: 6,
      });
    } catch (e) {
      console.error("Failed to initialize map:", e);
      return;
    }
    mapRef.current.flyTo({
      center: assetHistory?.features[0]?.geometry?.coordinates,
      essential: true, // This animation is considered essential with respect to prefers-reduced-motion
    });

    mapRef.current.on("load", () => {
      mapRef.current.addSource("earthquakes", {
        type: "geojson",
        data: assetHistory,
      });

      mapRef.current.addLayer(
        {
          id: "earthquakes-heat",
          type: "heatmap",
          source: "earthquakes",
          maxzoom: 9,
          paint: {
            // Increase the heatmap weight based on frequency and property magnitude
            "heatmap-weight": [
              "interpolate",
              ["linear"],
              ["get", "mag"],
              0,
              0,
              6,
              1,
            ],
            // Increase the heatmap color weight weight by zoom level
            // heatmap-intensity is a multiplier on top of heatmap-weight
            "heatmap-intensity": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              1,
              9,
              3,
            ],
            // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
            // Begin color ramp at 0-stop with a 0-transparancy color
            // to create a blur-like effect.
            "heatmap-color": [
              "interpolate",
              ["linear"],
              ["heatmap-density"],
              0,
              "rgba(33,102,172,0)",
              0.2,
              "rgb(103,169,207)",
              0.4,
              "rgb(209,229,240)",
              0.6,
              "rgb(253,219,199)",
              0.8,
              "rgb(239,138,98)",
              1,
              "rgb(255,128,39)",
            ],
            // Adjust the heatmap radius by zoom level
            "heatmap-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              0,
              2,
              9,
              20,
            ],
            // Transition from heatmap to circle layer by zoom level
            "heatmap-opacity": [
              "interpolate",
              ["linear"],
              ["zoom"],
              7,
              1,
              9,
              0,
            ],
          },
        },
        "waterway-label"
      );

      mapRef.current.addLayer(
        {
          id: "earthquakes-point",
          type: "circle",
          source: "earthquakes",
          minzoom: 7,
          paint: {
            // Size circle radius by earthquake magnitude and zoom level
            "circle-radius": [
              "interpolate",
              ["linear"],
              ["zoom"],
              7,
              ["interpolate", ["linear"], ["get", "mag"], 1, 1, 6, 4],
              16,
              ["interpolate", ["linear"], ["get", "mag"], 1, 5, 6, 50],
            ],
            // Color circle by earthquake magnitude
            "circle-color": [
              "interpolate",
              ["linear"],
              ["get", "mag"],
              1,
              "rgba(33,102,172,0)",
              2,
              "rgb(103,169,207)",
              3,
              "rgb(209,229,240)",
              4,
              "rgb(253,219,199)",
              5,
              "rgb(239,138,98)",
              6,
              "rgb(255,128,39)",
            ],
            "circle-stroke-color": "white",
            "circle-stroke-width": 1,
            // Transition from heatmap to circle layer by zoom level
            "circle-opacity": ["interpolate", ["linear"], ["zoom"], 7, 0, 8, 1],
          },
        },
        "waterway-label"
      );
    });
  }, [assetHistory]);

  useEffect(() => {
    dispatch(
      fetchAssetHistoryRequest({
        id,
      })
    );
   
    dispatch(
      fetchBatteryHistoryRequest({
        id,
      })
    );
    dispatch(
      fetchAcclerationHistoryRequest({
        id,
      })
    );
    dispatch(
      fetchSignalHistoryRequest({
        id,
      })
    );
    // dispatch(
    //   fetchLocationHistoryRequest({
    //     id,
    //   })
    // );
    dispatch(
      fetchGatewayTelemetryHistoryRequest({
        id,
      })
    );
    dispatch(
      fetchShockAlarmHistoryRequest({
        id,
      })
    );
  }, [dispatch, id, isRefresh, user?.accountId]);

  return (
    <>
      {/* <div className="view-device-dashboard-full">
        <div className="d-flex flex-column">
          <div className="single-device-card-title">Current Profile</div>
          <div className="d-flex flex-column mt-2 current-value-indicator">
            <div className="current-value-title">4 hour reporting</div>
            <div className="d-flex flex-row justify-content-start align-items-center current-value-count-container">
              <h5 className="px-2 font-face-vzw current-value-count">
                No motion
              </h5>
              <img
                src={shipping}
                width="24px"
                height="24px"
                alt="current-value-count"
              />
              <span className="px-1">4 hours ago</span>
            </div>
          </div>
        </div>
      </div> */}
      <div
        className="view-device-dashboard-full"
        id="batteryLevel"
        ref={batteryLevelFullScreenRef}
      >
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div className="single-device-card-title">Battery Level</div>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <SettingDropdown
                parentId="batteryLevel"
                parentRef={batteryLevelFullScreenRef}
                isFullScreen={true}
              />
              <ResolutionDropdown
                parentId="batteryLevel"
                onApply={handleBatteryResolution}
              />
            </div>
          </div>
          {isBatteryHistoryLoading || batteryHistory.battery.length > 0 ? (
            <>
              <div className="d-flex flex-column mt-2 current-value-indicator">
                <div className="current-value-title">Current level</div>
                <div className="d-flex flex-row justify-content-start align-items-center current-value-count-container">
                  <h5 className="px-2 font-face-vzw current-value-count">
                    {Array.isArray(batteryHistory[batteryHistory.length - 1]) &&
                      batteryHistory[batteryHistory.length - 1].length > 1 &&
                      batteryHistory.battery[
                        batteryHistory.battery.length - 1
                      ][1]}
                  </h5>
                  <img
                    src={battery}
                    width="24px"
                    height="24px"
                    alt="current-value-count"
                  />
                  <span className="px-1">{batteryHistory.timeAgo}</span>
                </div>
              </div>
              <ReactECharts
                showLoading={isBatteryHistoryLoading}
                style={{ height: "350px" }}
                option={{
                  ...batteryOptions,
                  series: [
                    {
                      ...batteryOptions.series[0],
                      data: [...batteryHistory.battery],
                    },
                  ],
                }}
                opts={{ renderer: "svg" }}
              />
            </>
          ) : (
            <NotFound style={{ height: "420px" }} />
          )}
        </div>
      </div>
      <div
        className="view-device-dashboard-full"
        id="shockAlarm"
        ref={shockAlarmFullScreenRef}
      >
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div className="single-device-card-title">Shock Alarm History</div>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <SettingDropdown
                parentId="shockAlarm"
                parentRef={shockAlarmFullScreenRef}
                isFullScreen={true}
              />
              <ResolutionDropdown
                parentId="shockAlarm"
                onApply={handleShockAlarmResolution}
              />
            </div>
          </div>
          {isShockAlarmHistoryLoading || shockAlarmHistory.shock.length > 0 ? (
            <>
              <div className="d-flex flex-column mt-2 current-value-indicator">
                <div className="current-value-title">Latest shock magnitude</div>
                <div className="d-flex flex-row justify-content-start align-items-center current-value-count-container">
                  <h5 className="px-2 font-face-vzw current-value-count">
                    {Array.isArray(shockAlarmHistory.shock) &&
                      shockAlarmHistory.shock.length > 0 &&
                      shockAlarmHistory.shock[
                        shockAlarmHistory.shock.length - 1
                      ][1]} G
                  </h5>
                  <span className="px-1">{shockAlarmHistory.timeAgo}</span>
                </div>
              </div>

              {/* Shock Analytics Dashboard
              <ShockAnalyticsDashboard shockData={shockAlarmHistory.shock} /> */}

              {/* Shock History Chart */}
              <ReactECharts
                showLoading={isShockAlarmHistoryLoading}
                style={{ height: "350px" }}
                option={{
                  ...shockOptions,
                  series: [
                    {
                      ...shockOptions.series[0],
                      data: shockAlarmHistory.shock.map(item => [item[0], item[1]]),
                    },
                  ],
                }}
                opts={{ renderer: "svg" }}
              />
            </>
          ) : (
            <NotFound style={{ height: "420px" }} />
          )}
        </div>
      </div>
      <div
        className="view-device-dashboard-full gpsHeatmap"
        id="gpsHeatmap"
        ref={gpsHeatMapFullScreenRef}
      >
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3 className="single-device-card-title">GPS Heatmap</h3>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <SettingDropdown
                parentId="gpsHeatmap"
                parentRef={gpsHeatMapFullScreenRef}
                isFullScreen={true}
              />
            </div>
          </div>
          <div
            ref={mapContainerRef}
            style={{ marginTop: "10px", width: "100%", height: "420px" }}
          ></div>
        </div>
      </div>
      <div
        className="view-device-dashboard-full signalHistory"
        id="signalHistory"
        ref={signalHistoryFullScreenRef}
      >
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3 className="single-device-card-title">Signal History</h3>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <SettingDropdown
                parentId="signalHistory"
                parentRef={signalHistoryFullScreenRef}
                isFullScreen={true}
              />
              <ResolutionDropdown parentId="signalHistory" onApply={handleSignalResolution}/>
            </div>
          </div>
          {isSignalHistoryLoading || signalHistory.length > 0 ? (
            <ReactECharts
              style={{ height: "451px" }}
              showLoading={isSignalHistoryLoading}
              option={{
                ...signalHistoryOptions,
                series: [
                  {
                    ...signalHistoryOptions.series[0],
                    data: [...signalHistory],
                  },
                ],
              }}
            />
          ) : (
            <NotFound style={{ height: "451px" }} />
          )}
        </div>
      </div>
      <div
        className="view-device-dashboard-full accelarationHistory"
        id="accelarationHistory"
        ref={accelarationHistoryFullScreenRef}
      >
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3 className="single-device-card-title">Acceleration History</h3>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <SettingDropdown
                parentId="accelarationHistory"
                parentRef={accelarationHistoryFullScreenRef}
                isFullScreen={true}
              />
              <ResolutionDropdown parentId="accelarationHistory" onApply={handleAcclerationResolution}/>
            </div>
          </div>
          {isAccelerationHistoryLoading ||
          accelerationHistory.accelerationX.length > 0 ||
          accelerationHistory.accelerationY.length > 0 ||
          accelerationHistory.accelerationZ.length > 0 ||
          accelerationHistory.accelerationRMS.length > 0 ? (
            <ReactECharts
              showLoading={isAccelerationHistoryLoading}
              style={{ height: "451px" }}
              option={{
                ...accelarationHistoryOptions,
                series: [
                  {
                    ...accelarationHistoryOptions.series[0],
                    data: [...accelerationHistory.accelerationX],
                  },
                  {
                    ...accelarationHistoryOptions.series[1],
                    data: [...accelerationHistory.accelerationY],
                  },
                  {
                    ...accelarationHistoryOptions.series[2],
                    data: [...accelerationHistory.accelerationZ],
                  },
                  {
                    ...accelarationHistoryOptions.series[3],
                    data: [...accelerationHistory.accelerationRMS],
                  },
                ],
              }}
            />
          ) : (
            <NotFound style={{ height: "451px" }} />
          )}
        </div>
      </div>
      {/* <div
        className="view-device-dashboard-full locationHistory"
        id="locationGatewayHistory"
        ref={locationGatewayHistoryFullScreenRef}
      >
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3 className="single-device-card-title">Location History</h3>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <SettingDropdown
                parentId="locationGatewayHistory"
                parentRef={locationGatewayHistoryFullScreenRef}
                isFullScreen={true}
              />
              
            </div>
          </div>
          {isLocationHistoryLoading || locationHistory.length > 0 ? (
            <LocationHistory
              isLoading={isLocationHistoryLoading}
              dataSource={locationHistory}
            />
          ) : (
            <NotFound style={{ height: "500px" }} />
          )}
        </div>
      </div> */}
      <div
        className="view-device-dashboard-full locationHistory"
        id="gatewayTelementry"
        ref={gatewayTelementryFullScreenRef}
      >
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <h3 className="single-device-card-title">
              Gateway Telemetry (Last 7 Days)
            </h3>
            <div className="d-flex flex-row justify-content-start align-items-center">
              <SettingDropdown
                parentId="gatewayTelementry"
                parentRef={gatewayTelementryFullScreenRef}
                isFullScreen={true}
              />
              {/* <ResolutionDropdown parentId="gatewayTelementry" /> */}
            </div>
          </div>
          {isGatewayTelemetryHistoryLoading ||
          gatewayTelemetryHistory.length > 0 ? (
            <GatewayTelemetry
              isLoading={isGatewayTelemetryHistoryLoading}
              dataSource={gatewayTelemetryHistory}
            />
          ) : (
            <NotFound style={{ height: "450px" }} />
          )}
        </div>
      </div>
    </>
  );
}

GatewayDeviceDashboard.propTypes = {
  id: PropTypes.string.isRequired,
  isRefresh: PropTypes.bool.isRequired,
};

export default GatewayDeviceDashboard;
